import { render } from "./Complaints.vue?vue&type=template&id=115a913b&scoped=true"
import script from "./Complaints.vue?vue&type=script&lang=js"
export * from "./Complaints.vue?vue&type=script&lang=js"

import "./Complaints.vue?vue&type=style&index=0&id=115a913b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115a913b"]])

export default __exports__